export const isApplePayAvailable = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return 'ApplePaySession' in window && typeof window.ApplePaySession?.canMakePayments === 'function' && window.ApplePaySession.canMakePayments();
};
